<template>
  <div class="main">
    <Header />
    <Aside />
    <div class="main__body">
      <router-view />
    </div>
  </div>
</template>


<script>
import Header from "./Header";
import Aside from './Aside';

export default {
  name: "Layout",
  components: {
    Header,
    Aside
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/variables.scss";

.main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  min-width: 1200px;
}
.main__body {
  position: absolute;
  top: $header-height;
  bottom: 0px;
  left: $aside-width;
  right: 0px;
  padding: 20px;
  background-color: white;
  overflow-x: hidden;
  overflow-y: auto;
}
.main__body::-webkit-scrollbar {
  width: 10px;
  background-color: white;
}
.main__body::-webkit-scrollbar-track {
  background-color: white;
}
.main__body::-webkit-scrollbar-thumb {
  background-color: #f6f7fb;
}
</style>
